export { default } from "./ProcessWorkflowsText";
